import React from 'react';
import { useTranslation } from 'react-i18next';

import SearchableSelectField from 'components/layout/forms/SearchableSelectField';
import { toOptions, useChoiceList } from 'services/offers/offerChoices';
import translations from 'services/translations/translations';

// The value of an attribute from its choice list (e.g. product-edge), managed on the admin
// page of the choice lists
const ProductAttributeDropdown = ({
  index,
  item,
  list,
  type,
  updateAttributeRow,
}: {
  index: number;
  item: any;
  list: string;
  type: string;
  updateAttributeRow: any;
}): JSX.Element => {
  const { t } = useTranslation([translations.products]);
  const options = useChoiceList(list, item.value);

  return (
    <SearchableSelectField
      label={index === 0 ? t(`${translations.products}:Value`) : undefined}
      required
      id={type}
      name="value"
      value={item.value ?? ''}
      onChange={(e: any) => updateAttributeRow(e, index)}
      options={toOptions(options)}
    />
  );
};

export default ProductAttributeDropdown;
